import { useRef, useState } from "react";

import AddRespondentsToGroup from "Signups/SharedComponents/AddRespondentsToGroup";

import FnrIcon from "UI/FnrIcon";
import { FnrToggleChild } from "UI/FnrToggle2";

import { Icon, RespondentsDataButton, SubText, Text, Title } from "./styles";

export default function AddToGroup({ disabled = false }) {
  const addToGroupButtonRef = useRef();
  const [showAddToGroupPopover, setShowAddToGroupPopover] = useState(false);

  const toggleAddToGroupPopover = () => {
    setShowAddToGroupPopover((currentVal) => !currentVal);
  };

  return (
    <>
      <FnrToggleChild forceHover={showAddToGroupPopover} disabled={disabled}>
        <RespondentsDataButton
          ref={addToGroupButtonRef}
          onClick={disabled ? null : toggleAddToGroupPopover}
        >
          <Icon>
            <FnrIcon fad fa-users />
          </Icon>
          <Text>
            <Title>Add all respondents to a group</Title>
            <SubText>
              {
                "Click here to add all of this Signup's respondents to one of your groups."
              }
            </SubText>
          </Text>
        </RespondentsDataButton>
      </FnrToggleChild>

      <AddRespondentsToGroup
        show={showAddToGroupPopover}
        setShow={setShowAddToGroupPopover}
        buttonRef={addToGroupButtonRef}
      />
    </>
  );
}
